// extracted by mini-css-extract-plugin
export var attachmentPill = "attachments-module--attachment-pill--9fc7d";
export var childList = "attachments-module--child-list--ac35a";
export var childListItem = "attachments-module--child-list-item--351f6";
export var extensions = "attachments-module--extensions--9cbaf";
export var fullWidth = "attachments-module--full-width--68eb0";
export var list = "attachments-module--list--04c58";
export var listTitle = "attachments-module--list-title--23357";
export var loader = "attachments-module--loader--0feb4";
export var separator = "attachments-module--separator--90005";
export var titleWrapper = "attachments-module--title-wrapper--8a3ff";